module.exports = {
  host: '/api',
  service: {
    callback: 'https://service-callback.epopark.com'
  },
  wxs: {
    id: '5a603d39e4b401158030707e',
    mobile: '15988545765',
    token: 'e9bd6be3cc2a8761deb536b409b5842e',
    debug: false,
  },
  alipay: {
    appId: '2016072601668181'
  }
};
